import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const JoinNow: FC = () => {
  const router = useRouter();

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.label} color="white" variant="h5">
        Want To Join Our Network Of Trusted Vendors?
      </Label>
      <Button
        variant="secondary"
        onClick={() => {
          router.push("/vendors/#form");
        }}
      >
        Join now
      </Button>
    </Content>
  );
};

export default JoinNow;
